namespace GeniuzPOS.Administration {
    export enum PsParaGenTypePrintOrderFg {
        PrintOrderFg0 = 0,
        PrintOrderFg1 = 1,
        PrintOrderFg2 = 2
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypePrintOrderFg, 'GeniuzPOS.Administration.PsParaGenTypePrintOrderFg', 'Administration.PsParaGenTypePrintOrderFg');
}
